import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { ListUsersComponent } from './components/list-users/list-users.component';
import { FormsModule } from '@angular/forms';
import { UserDetailsModalComponent } from './components/user-details-modal/user-details-modal.component';
import { DeleteUserConfirmationModalComponent } from './components/delete-user-confirmation-modal/delete-user-confirmation-modal.component';
import { DesktopNavbarComponent } from './components/navbar/components/desktop-navbar/desktop-navbar.component';
import { MobileNavbarComponent } from './components/navbar/components/mobile-navbar/mobile-navbar.component';
import { ClipboardModule } from 'ngx-clipboard';


@NgModule({
  declarations: [
    NavbarComponent,
    ListUsersComponent,
    UserDetailsModalComponent,
    DeleteUserConfirmationModalComponent,
    DesktopNavbarComponent,
    MobileNavbarComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    FormsModule,
    ClipboardModule
  ],
  exports: [
    NavbarComponent,
    ListUsersComponent,
    UserDetailsModalComponent,
    DeleteUserConfirmationModalComponent,
  ],
})
export class SharedModule {}
